import Button from 'components/Button'
import Checkbox from 'components/Checkbox/Checkbox'
import Control from 'components/Control/Control'
import Flex from 'components/Flex'
import EmailIcon from 'components/icons/EmailIcon'
import WhatsApp from 'components/icons/WhatsApp'
import { activeStatus } from '../../actions'
import {
  Container,
  Content,
  Heading,
  Table,
  TableHeading,
  TableSubText,
  TableText,
  Wrapper,
} from 'modules/Onboarding/Register/Notification/style'
import {
  getCollege,
  getStudentData,
  updateCurrentState,
  updateNotification,
} from 'modules/Onboarding/actions'
import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate, useParams } from 'react-router-dom'
import ErrorMessage from 'utils/ErrorMessage'
const { AUTH_URL } = process.env

const Notification = () => {
  const params = useParams()
  const studentId = params.studentId
  const dispatch = useDispatch()
  const navigate = useNavigate()
  let stdData = useSelector(state => state?.studentData?.studentDetails)

  const checked = true
  const [whatsAppCheck, setWhatsAppCheck] = useState(true)
  const [emailCheck, setEmailCheck] = useState(true)

  const submitHandler = async () => {
    let payload = {
      email: emailCheck,
      whatsapp: whatsAppCheck,
    }
    if (checked) {
      let res = await dispatch(updateNotification(stdData?.admin?._id, payload))
      dispatch(activeStatus(studentId, { status: 2 }))  

      if (res === true) {
        let response = await dispatch(updateCurrentState(studentId, 4))
        if(response){
           navigate(`/dashboard`)       
        }
      } else {
        ErrorMessage(res?.message || 'Error while update notification')
      }
    } else {
      ErrorMessage('Please accept Terms and Conditions to continue')
    }
  }

  const onBack = async () => {
    let response = await dispatch(updateCurrentState(studentId, 2))
    if (response === true) navigate(`/onboarding/register/${studentId}`)
  }

  const handleWapCheck = e => {
    setWhatsAppCheck(e.target.checked)
  }

  const handleEmailCheck = e => {
    setEmailCheck(e.target.checked)
  }

  useEffect(() => {
    if (studentId) {
      dispatch(getStudentData(studentId))
    }
  }, [studentId])

  useEffect(() => {
    if (stdData?.instituteCampusId) {
      dispatch(getCollege(stdData?.instituteCampusId))
    }
  }, [stdData])

  useEffect(() => {
    if (stdData?.currentState === 0 || stdData?.currentState === -1) {
      navigate(`/onboarding/activate/${studentId}`)
    } 
    // else if (stdData?.currentState === 1) {
    //   navigate(`/onboarding/final/${studentId}`)
    // } else if (stdData?.currentState === 3) {
    //   navigate(`/onboarding/notification/${studentId}`)
    // } else if (stdData?.currentState === 4) {
    //   navigate(`/dashboard`)
    // }
    else {
      navigate(`/dashboard`)
    }
  }, [stdData])

  return (
    <Container alignCenter column center>
      <Content spaceBetween flexStart column>
        <Flex column>
          <Heading>One last thing</Heading>
          <TableHeading>How do you want to get notified?</TableHeading>
        </Flex>
        <Flex column>
          <Flex column>
            <Table spaceBetween>
              <Flex alignCenter center>
                <Checkbox value={whatsAppCheck} onChange={handleWapCheck} />
                <Wrapper>
                  <WhatsApp />
                </Wrapper>
                <Wrapper column>
                  <TableText>Whatsapp Notification</TableText>
                  <TableSubText>
                    Get all your notification in your whatsapp number.
                  </TableSubText>
                </Wrapper>
              </Flex>
            </Table>
            <Table spaceBetween>
              <Flex alignCenter flexEnd>
                <Checkbox value={emailCheck} onChange={handleEmailCheck} />
                <Wrapper>
                  <EmailIcon />
                </Wrapper>
                <Wrapper column>
                  <TableText>Email Notification</TableText>
                  <TableSubText>
                    Get all your notification in your registered email
                  </TableSubText>
                </Wrapper>
              </Flex>
            </Table>
          </Flex>
        </Flex>
        <Control width="100%" flexEnd gap="15px" top="35px">
          <Button.Secondary text="Back" onClick={() => onBack()} />
          <Button.Primary
            text="Save & Continue"
            onClick={() => submitHandler()}
          />
        </Control>
      </Content>
    </Container>
  )
}

export default Notification
